interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps) => {
  const greenColor = "hsl(var(--primary))";

  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={greenColor}
        d="M100 50c0-27.61-22.39-50-50-50S0 22.39 0 50s22.39 50 50 50 50-22.39 50-50Z"
      />
      <path
        fill="#0B151E"
        d="M19.59 68.38 37.31 23h5.91L25.43 68.38h-5.85.01ZM68.98 48.02h-5.91c-1.01-3.9-4.15-5.97-8.11-5.97-5.59 0-9.43 4.27-9.43 10.94s3.58 10.87 9.18 10.87c4.21 0 7.35-2.2 8.42-5.85h5.91c-1.19 6.66-6.91 11.12-14.33 11.12-9.05 0-15.02-6.41-15.02-16.09s6.1-16.31 15.09-16.28c7.45.03 13.04 4.31 14.2 11.25v.01ZM72.18 64.74c0-2.45 2.07-4.46 4.53-4.46a4.47 4.47 0 0 1 4.46 4.46c0 2.45-2.07 4.4-4.46 4.4s-4.53-2.01-4.53-4.4Z"
      />
    </svg>
  );
};

export function LogoType({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 300 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.21875 48.7523L18.7928 1.19531H24.9842L6.34494 48.7523H0.21875Z"
        fill="currentColor"
      />
      <path
        d="M37.0884 15.6207C45.1902 15.6207 50.8547 20.2312 51.9756 27.4112H45.7842C44.7303 23.3277 41.4363 21.1529 37.2876 21.1529C31.4258 21.1529 27.4075 25.6312 27.4075 32.6138C27.4075 39.5966 31.1615 44.0096 37.025 44.0096C41.4381 44.0096 44.7321 41.7044 45.8512 37.8835H52.0426C50.7913 44.8662 44.7973 49.5418 37.025 49.5418C27.5397 49.5418 21.2832 42.8235 21.2832 32.679C21.2832 22.5346 27.6719 15.6189 37.0921 15.6189L37.0884 15.6207Z"
        fill="currentColor"
      />
      <path
        d="M71.9265 15.686C81.544 15.686 88.6575 22.6687 88.6575 32.614C88.6575 42.5593 81.544 49.542 71.9265 49.542C62.309 49.542 55.1309 42.5593 55.1309 32.614C55.1309 22.6687 62.2438 15.686 71.9265 15.686ZM71.9265 44.0098C78.1181 44.0098 82.4659 39.3323 82.4659 32.614C82.4659 25.8957 78.1181 21.2182 71.9265 21.2182C65.7354 21.2182 61.3876 25.8957 61.3876 32.614C61.3876 39.3323 65.6681 44.0098 71.9265 44.0098Z"
        fill="currentColor"
      />
      <path
        d="M92.0762 32.7462C92.0762 22.866 97.8079 15.6208 107.358 15.6208C112.298 15.6208 116.449 17.7938 118.622 21.7469V0.273682H124.748V48.7524H119.216L118.689 42.8907C116.581 47.3037 112.233 49.5438 107.096 49.5438C97.7428 49.5438 92.0784 42.561 92.0784 32.748L92.0762 32.7462ZM118.555 32.5488C118.555 25.9627 114.669 21.22 108.345 21.22C102.022 21.22 98.3329 25.9627 98.3329 32.5488C98.3329 39.1349 102.022 43.9445 108.345 43.9445C114.669 43.9445 118.555 39.2671 118.555 32.5488Z"
        fill="currentColor"
      />
      <path
        d="M128.303 32.6813C128.303 22.6038 134.691 15.6211 144.045 15.6211C153.398 15.6211 159.195 21.9446 159.195 31.4951V33.8004L134.297 33.8656C134.759 40.6509 138.315 44.4048 144.441 44.4048C149.249 44.4048 152.411 42.4292 153.465 38.7404H159.261C157.68 45.6561 152.279 49.5423 144.309 49.5423C134.824 49.5423 128.303 42.6918 128.303 32.6795V32.6813ZM134.429 29.7169H153.005C153.005 24.3821 149.514 20.8255 144.047 20.8255C138.579 20.8255 135.22 24.0525 134.429 29.7169Z"
        fill="currentColor"
      />
      <path
        d="M162.818 48.7528V16.5428H168.351L168.943 20.7585C170.589 17.729 174.015 15.6211 178.56 15.6211C183.565 15.6211 187.124 18.1237 188.77 22.142C190.286 18.1237 194.172 15.6211 199.177 15.6211C206.554 15.6211 211.033 20.2316 211.033 27.6742V48.7528H204.974V29.1899C204.974 24.1177 202.141 21.2203 197.794 21.2203C193.116 21.2203 190.021 24.5143 190.021 29.6517V48.7528H183.895V29.1248C183.895 24.0525 181.128 21.2855 176.782 21.2855C172.105 21.2855 169.01 24.5125 169.01 29.6499V48.7509H162.818V48.7528Z"
        fill="currentColor"
      />
      <path
        d="M231.975 15.686C241.593 15.686 248.706 22.6687 248.706 32.614C248.706 42.5593 241.593 49.542 231.975 49.542C222.358 49.542 215.18 42.5593 215.18 32.614C215.18 22.6687 222.293 15.686 231.975 15.686ZM231.975 44.0098C238.166 44.0098 242.515 39.3323 242.515 32.614C242.515 25.8957 238.166 21.2182 231.975 21.2182C225.784 21.2182 221.436 25.8957 221.436 32.614C221.436 39.3323 225.717 44.0098 231.975 44.0098Z"
        fill="currentColor"
      />
      <path
        d="M252.125 32.7462C252.125 22.866 257.856 15.6208 267.407 15.6208C272.347 15.6208 276.497 17.7938 278.671 21.7469V0.273682H284.797V48.7524H279.265L278.737 42.8907C276.63 47.3037 272.282 49.5438 267.144 49.5438C257.791 49.5438 252.127 42.561 252.127 32.748L252.125 32.7462ZM278.603 32.5488C278.603 25.9627 274.718 21.22 268.394 21.22C262.07 21.22 258.381 25.9627 258.381 32.5488C258.381 39.1349 262.07 43.9445 268.394 43.9445C274.718 43.9445 278.603 39.2671 278.603 32.5488Z"
        fill="currentColor"
      />
      <path
        d="M290.328 44.9331C290.328 42.3634 292.501 40.2556 295.071 40.2556C297.64 40.2556 299.748 42.3634 299.748 44.9331C299.748 47.5027 297.575 49.5436 295.071 49.5436C292.566 49.5436 290.328 47.4357 290.328 44.9331Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CodemodAILogo({ className }: LogoProps) {
  const fromcolor = "hsl(var(--primary))";
  const toColor = "hsl(var(--primary)/0.2)";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fill="url(#a)"
        d="M8 9.5c.275 0 .5.22.5.5h1c0-.28.22-.5.5-.5v-1c-.28 0-.5-.225-.5-.5h-1c0 .275-.225.5-.5.5v1Zm0-1c-.67 0-.67 1 0 1 .825 0 1.5-.675 1.5-1.5 0-.67-1-.67-1 0 0 .825.67 1.5 1.5 1.5.665 0 .665-1 0-1-.83 0-1.5.67-1.5 1.5 0 .665 1 .665 1 0 0-.83-.675-1.5-1.5-1.5Zm0-5c.275 0 .5.22.5.5h1c0-.28.22-.5.5-.5v-1c-.28 0-.5-.225-.5-.5h-1c0 .275-.225.5-.5.5v1Zm0-1c-.67 0-.67 1 0 1 .825 0 1.5-.675 1.5-1.5 0-.67-1-.67-1 0 0 .825.67 1.5 1.5 1.5.665 0 .665-1 0-1-.83 0-1.5.67-1.5 1.5 0 .665 1 .665 1 0 0-.83-.675-1.5-1.5-1.5ZM5 9c0-1.385 1.115-2.5 2.5-2.5v-1C6.115 5.5 5 4.38 5 3H4a2.5 2.5 0 0 1-2.5 2.5v1C2.88 6.5 4 7.615 4 9h1ZM4 9c0 .665 1 .665 1 0a3.5 3.5 0 0 0-3.5-3.5c-.67 0-.67 1 0 1C3.43 6.5 5 4.93 5 3c0-.67-1-.67-1 0a3.5 3.5 0 0 0 3.5 3.5c.665 0 .665-1 0-1A3.497 3.497 0 0 0 4 9Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="10"
          x2="1"
          y1="1"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={toColor} />
          <stop offset="1" stopColor={fromcolor} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CodemodAILogoLiquid({ className }: LogoProps) {
  const fromColor = "hsl(var(--primary))";
  const toColor = "hsl(var(--primary)/0.2)";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={49}
      height={49}
      fill="none"
      viewBox="0 0 49 49"
      className={className}
    >
      <g filter="url(#a)">
        <rect width={48} height={48} x=".5" y=".013" fill="url(#b)" rx={24} />
      </g>
      <path
        fill="url(#c)"
        d="M29.834 33.333c.733 0 1.333.587 1.333 1.334h2.666a1.32 1.32 0 0 1 1.334-1.334v-2.666c-.747 0-1.334-.6-1.334-1.334h-2.666c0 .734-.6 1.334-1.334 1.334v2.666Zm0-2.666c-1.787 0-1.787 2.666 0 2.666 2.2 0 4-1.8 4-4 0-1.786-2.667-1.786-2.667 0 0 2.2 1.786 4 4 4 1.773 0 1.773-2.666 0-2.666-2.214 0-4 1.786-4 4 0 1.773 2.666 1.773 2.666 0 0-2.214-1.8-4-4-4Zm0-13.334c.733 0 1.333.587 1.333 1.334h2.666a1.32 1.32 0 0 1 1.334-1.334v-2.666c-.747 0-1.334-.6-1.334-1.334h-2.666c0 .734-.6 1.334-1.334 1.334v2.666Zm0-2.666c-1.787 0-1.787 2.666 0 2.666 2.2 0 4-1.8 4-4 0-1.786-2.667-1.786-2.667 0 0 2.2 1.786 4 4 4 1.773 0 1.773-2.666 0-2.666-2.214 0-4 1.786-4 4 0 1.773 2.666 1.773 2.666 0 0-2.214-1.8-4-4-4Zm-8 17.333a6.652 6.652 0 0 1 6.666-6.667v-2.666A6.66 6.66 0 0 1 21.834 16h-2.667a6.669 6.669 0 0 1-6.667 6.667v2.666A6.66 6.66 0 0 1 19.167 32h2.666Zm-2.667 0c0 1.773 2.666 1.773 2.666 0 0-5.16-4.186-9.333-9.333-9.333-1.787 0-1.787 2.666 0 2.666 5.147 0 9.334-4.186 9.334-9.333 0-1.787-2.667-1.787-2.667 0 0 5.147 4.173 9.333 9.333 9.333 1.773 0 1.773-2.666 0-2.666A9.327 9.327 0 0 0 19.167 32Z"
      />
      <defs>
        <linearGradient
          id="b"
          x1="24.5"
          x2="24.5"
          y1=".013"
          y2="48.013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fromColor} stopOpacity=".4" />
          <stop offset={1} stopColor={fromColor} stopOpacity=".2" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="35.167"
          x2="11.167"
          y1="10.667"
          y2="34.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={toColor} />
          <stop offset={1} stopColor={fromColor} />
        </linearGradient>
        <filter
          id="a"
          width={48}
          height={57}
          x=".5"
          y="-1.987"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={7} />
          <feGaussianBlur stdDeviation="4.5" />
          <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.637325 0 0 0 0 0.806169 0 0 0 0 0.15962 0 0 0 0.55 0" />
          <feBlend in2="shape" result="effect1_innerShadow_5846_4521" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={-2} />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.0431373 0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0.4 0" />
          <feBlend
            in2="effect1_innerShadow_5846_4521"
            result="effect2_innerShadow_5846_4521"
          />
        </filter>
      </defs>
    </svg>
  );
}
